import parse from "html-react-parser";

export default function DynamicRadioField({field, value, onFieldChange, error, instanceId}) {
    const hasError = Boolean(error);
    const inputName = `${field.code}-${instanceId}`;

    const makeId = (opt) =>
        `${inputName}-${String(opt).replace(/\s+/g, "-").replace(/[^a-zA-Z0-9-_]/g, "")}`;

    return <div className="">

        <label className="text-x font-medium" >
            {field.name}
            {field.required && <span className="text-red-600 ml-1">*</span>}
        </label>

        {field.help && (
            <div className="text-sm text-gray-500 mt-1 mb-2">
                {parse(field.help)}
            </div>
        )}

        <div
            className={`
                    flex items-center gap-6 w-full h-10 px-3 py-2 rounded-lg border transition-all
                    ${hasError
                ? "border-red-500 bg-red-50"
                : "border-white focus-within:ring-2 focus-within:ring-[#2f855a]"
            }
                `}
        >

            {field.values.map((opt) => {
                const id = makeId(opt);
                return (
                    <label
                        key={id}
                        htmlFor={id}
                        className="flex items-center gap-2 cursor-pointer select-none"
                    >
                        <input
                            id={id}
                            name={inputName}
                            type="radio"
                            value={opt}
                            checked={value === opt}
                            onChange={onFieldChange}
                            className={`accent-[#1C3353] ${hasError ? "ring-red-500" : ""}`}
                            aria-checked={value === opt}
                        />
                        <span className="text-sm">{opt}</span>
                    </label>
                );
            })}

        </div>
        {error && (
            <div className="text-red-600 text-sm mt-1">
                {error}
            </div>
        )}

    </div>

}